import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import FilterDrawer from './FilterDrawer';
import Mileage from './Mileage';
import Year from './Year';

export default function YearAndMileage() {
  const isDealership = useIsDealershipPage();

  return (
    <FilterDrawer
      testId="facet-year-mileage"
      facetContent={true}
      facetName={isDealership ? 'Year' : 'Year & Mileage'}
    >
      <Year />
      {!isDealership && (
        <>
          <div className="my-3xl border-b border-b-border-subtle" />
          <Mileage />
        </>
      )}
    </FilterDrawer>
  );
}
